/* eslint-disable no-unused-vars */
/* eslint-disable import/newline-after-import */
/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint-disable no-shadow */
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Route } from 'react-router-dom'

import styles from '../../../resources/theme/global.js'
import { useQueryParams } from '../../../util/utils.js'
import { usePermissions } from '../../../hooks/usePermission'
import { fetchAttendanceInit } from '../AttendanceActions.js'

import Filter from './Filter.jsx'
import List from './List.jsx'
import Payment from './PaymentDetails.js'

import colors from '../../../assets/colors.jsx'
import ModalShowVisits from './ModalShowVisits.js'
import ArchiveOrcament from './ArchiveOrcament.jsx'
import DeleteService from './DeleteService.jsx'
import { useLocation } from 'react-router-dom'
import { Visualization } from './Visualization/index.jsx'
import History from './History/index.jsx'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'

const Attendance = props => {
  const { classes } = props

  const location = useLocation()
  const dispatch = useDispatch()

  const filters = useQueryParams(location?.search)

  const origin = useMemo(() => {
    return filters?.origin || ''
  }, [location])

  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate, canRead, canUpdate, canDelete, hasPermission } =
    usePermissions()

  useEffect(() => {
    dispatch(
      fetchAttendanceInit(filters, filters?.rows || 10, filters?.page || 1)
    )
  }, [location])

  return (
    <>
      <Grid
        container
        className={classes.pageHead}
        spacing={2}
        alignItems="center"
      >
        <Grid item xs={12}>
          <BaseCreatePage
            path="Atendimentos"
            pageLink="/attendance"
            hiddenReturn
            goBack={Boolean(origin)}
          />
        </Grid>

        <Grid item xs={12}>
          <Filter classes={classes} />
        </Grid>
      </Grid>

      {canCreate('atendimentos', permissionUser) && (
        <Link to="/attendance/new" />
      )}

      {canUpdate('atendimentos', permissionUser) && (
        <Route path="/attendance/:id/visualization" component={Visualization} />
      )}

      {canRead('atendimentos', permissionUser) && (
        <Route path="/attendance/:id/history" component={History} />
      )}

      {canUpdate('atendimentos', permissionUser) && (
        <Link to="/attendance/:id/edit" />
      )}

      {canCreate('lancamento-contas', permissionUser) && (
        <Route path="/attendance/:id/payment" component={Payment} />
      )}

      {canRead('atendimentos', permissionUser) && (
        <Route path="/attendance/visits/:id" component={ModalShowVisits} />
      )}

      {canDelete('atendimentos', permissionUser) && (
        <Route
          path="/attendance/archive-orcament/:id"
          component={ArchiveOrcament}
        />
      )}

      {canDelete('atendimentos', permissionUser) && (
        <Route path="/attendance/delete/:id" component={DeleteService} />
      )}

      {canRead('atendimentos', permissionUser) && <List />}
    </>
  )
}

export default withStyles(styles)(Attendance)
